import styled from "styled-components";
import { Breadcrumbs } from "~/components/breadcrumbs";
import { Filters } from "~/components/filters";
import { getColor, getSize, responsive } from "~/helpers/style";
import { UIProps } from "~/types/style";
import Button from "~/components/ui/Button";
import FlexContainer from "~/components/ui/FlexContainer";

export const ProductsContainer = styled.div`
  isolation: isolate;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: ${getSize(2.4)};
  margin-top: ${getSize(2.0)};

  ${responsive("desktop")} {
    grid-template-columns: repeat(4, 1fr) !important;
  }

  ${responsive("tablet")} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ProductsContainerSkeleton = styled.div`
  .skeleton-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: ${getSize(2.4)};
    margin-top: ${getSize(2.0)};

    ${responsive("desktop")} {
      grid-template-columns: repeat(4, 1fr) !important;
    }

    ${responsive("tablet")} {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .skeleton {
    border-radius: ${getSize(0.6)};
    height: ${getSize(36.0)};
    width: 100%;
  }
`;

export const FlexContainerRelative = styled(FlexContainer)`
  position: relative;
`;

export const AbsoluteIcon = styled.div`
  position: absolute;
  left: ${getSize(1.6)};
`;

export const ImageSearchButton = styled(Button)`
  position: absolute;
  right: ${getSize(0.6)};
  align-self: center;
`;

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-top: ${getSize(2.0)};
`;


export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 0 ${getSize(2.0)} 0;
  gap: ${getSize(0.7)};

  ${responsive("tablet", true)} {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: 14px 0 0 0;
    gap: 8px;
    overflow: hidden;

    & > * {
      /* allow each filter/button to shrink equally */
      flex: 1 1 0;
      min-width: 0;
    }
  }
`;

interface IActiveComponent extends UIProps {
  active: boolean;
}

export const BooleanFilterButton = styled(Button)<IActiveComponent>`
  font-weight: 500;
  font-size: ${getSize(1.4)};
  line-height: ${getSize(1.4)};
  padding: ${getSize(1.4)} ${getSize(1.2)};
  border: solid 1px
    ${({ active }) => (active ? getColor("primary") : "transparent")};

  ${responsive("tablet", true)} {
    font-size: ${getSize(1.2)};
    line-height: ${getSize(1.2)};
    padding: ${getSize(1.2)} ${getSize(1.0)};
  }
`;


export const StyledFilter = styled(Filters)<IActiveComponent>`
  margin-left: 0;

  & > button {
    font-weight: 500;
    font-size: ${getSize(1.4)};
    line-height: ${getSize(1.4)};
    padding: ${getSize(1.4)} ${getSize(1.2)};
    border: solid 1px
      ${({ active }) => (active ? getColor("primary") : "transparent")};
  }

  ${responsive("tablet", true)} {
    & > button {
      font-size: ${getSize(1.2)};
      line-height: ${getSize(1.2)};
      padding: ${getSize(1.2)} ${getSize(1.0)};
    }

    /* keep your full-screen dropdown override */
    & > div {
      position: relative;
      left: -70vw;
      margin-top: 10px;
      width: 100vw;

      button {
        justify-content: flex-end;
        width: 100%;
      }
    }

    & > button > div > div {
      margin-right: 6px;
    }
  }
`;

export const Container = styled.div`
  ${responsive("tablet", true)} {
    .search__divider {
      display: none;
    }
  }
`;